import {enableProdMode} from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { environment } from './environments/environment';
import 'hammerjs';
import {AppBrowserModule} from "./app/app.browser.module";

if (environment.production) {
  enableProdMode();
}

function bootstrap() {
  platformBrowserDynamic().bootstrapModule(AppBrowserModule)
  .then(() => document.documentElement.setAttribute('data-wtg-ready', 'true'))
  .catch(err => console.error(err));
}

if (document.readyState !== 'loading') {
  bootstrap();
} else {
  document.addEventListener('DOMContentLoaded', bootstrap, {once: true});
}
